document.addEventListener('variant:changed', function (evt) {
  const variant = evt.detail.variant;
  const submitButton = document.querySelector('.product-form__submit');
  const form = document.querySelector('form[is="product-form"]');

  if (!variant || !submitButton) return;

  const isPreOrder =
    variant.available &&
    variant.inventory_management === "shopify" &&
    variant.inventory_policy === "continue" &&
    variant.inventory_quantity < 1;

  // Reset
  const hiddenInput = form.querySelector('input[name="properties[Order]"]');
  if (hiddenInput) hiddenInput.remove();
  const note = document.querySelector('.preorder-note');
  if (note) note.remove();

  if (isPreOrder) {
    submitButton.querySelector('.btn__text').innerHTML = window.theme.strings.pre_order;
    form.insertAdjacentHTML(
      'beforeend',
      '<input type="hidden" name="properties[Order]" value="Pre-order">'
    );
    form.insertAdjacentHTML(
      'afterend',
      '<p class="preorder-note" style="color:red; margin-bottom:10px;">' +
      window.theme.strings.pre_order_description +
      '</p>'
    );
  } else {
    submitButton.querySelector('.btn__text').innerHTML = window.theme.strings.add_to_cart;
  }
});

document.addEventListener('variant:changed', function (evt) {
  const variant = evt.detail.variant;
  if (!variant) return;

  const stickyButtons = document.querySelectorAll('.sticky-atc-bar button[type="submit"], sticky-atc-bar-minimalist button[type="submit"]');
  const stickyForms = document.querySelectorAll('.sticky-atc-bar form, sticky-atc-bar-minimalist');

  stickyButtons.forEach(btn => {
    const form = btn.closest('form') || btn.closest('sticky-atc-bar-minimalist');

    // Reset
    form.querySelectorAll('input[name="properties[Order]"]').forEach(el => el.remove());
    const oldNotes = form.parentElement.querySelectorAll('.preorder-note');
    oldNotes.forEach(el => el.remove());

    const isPreOrder =
      variant.available &&
      variant.inventory_management === "shopify" &&
      variant.inventory_policy === "continue" &&
      variant.inventory_quantity < 1;

    if (isPreOrder) {
      btn.querySelector('.btn__text').innerHTML = window.theme.strings.pre_order;

      form.insertAdjacentHTML(
        'beforeend',
        '<input type="hidden" name="properties[Order]" value="Pre-order">'
      );

      form.insertAdjacentHTML(
        'beforebegin',
        '<p class="preorder-note" style="color:red; margin-bottom:8px;">' +
        window.theme.strings.pre_order_description +
        '</p>'
      );
    } else {
      btn.querySelector('.btn__text').innerHTML = window.theme.strings.add_to_cart;
    }
  });
});